import React, { useEffect, useState } from "react";
import {useStore} from "../../store";
import {ColumnsType} from "antd/lib/table";
import {Button, Col, Collapse, Form, Modal, Pagination, Row, Space, Table, Tabs, Badge, Tooltip} from "antd";
import Input from "antd/es/input/Input";
import {DownOutlined, RedoOutlined, RightOutlined, SearchOutlined, UpOutlined} from "@ant-design/icons";
import {observer} from "mobx-react";
import styled from "styled-components";
import AtlasDetail from "./atlas-detail";
import {transaction} from "mobx";
import { AtlasEntity } from "../../entity/atlas-entity";
import { AtlasEntityInfo } from '../../entity/atlas-entity-info';
import type { TabsProps } from 'antd';
import type { TableColumnsType } from 'antd';

const AtlasList:React.FC = () => {

    const store = useStore();
    const [form] = Form.useForm();
    const {imageLibraryStore} = store;
    const [ tabKey, setTabKey ] = useState('0')
    useEffect(() => {
        onQuery()
        return clear;
    }, [])

    const clear = () => {
        imageLibraryStore.frontClear();
    }

    const onClose = () => {
        imageLibraryStore.isFrontDetailOpen = false;
    }
    const onExpendClick = () => {
        const isExpend = imageLibraryStore.isFrontExpend;
        imageLibraryStore.isFrontExpend = !isExpend;
    }

    const columns: ColumnsType<AtlasEntity> = [
        // {
        //     title: '图谱编号',
        //     width: 120,
        //     dataIndex: 'atlasNumber',
        //     key: 'atlasNumber',
        //     align: "center"
        // },
        // {
        //     title: '采样编号',
        //     width: 100,
        //     dataIndex: 'sampleNumber',
        //     key: 'sampleNumber',
        //     align: "center"
        // },
        {
            title: '药材名',
            dataIndex: 'medicineName',
            key: 'medicineName',
            align: "center",
            className: "FirstLevelHeaderWrapper"
        },
        {
            title: '基原植物',
            dataIndex: 'originalPlant',
            key: 'originalPlant',
            className: "FirstLevelHeaderWrapper",
            align: "center"
        },
        {
            title: '拉丁名',
            dataIndex: 'latinName',
            key: 'latinName',
            className: "FirstLevelHeaderWrapper",
            align: "center",
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    {text}
                </Tooltip>
            ),
        },
        {
            title: '样品来源',
            dataIndex: 'sampleSource',
            key: 'sampleSource',
            className: "FirstLevelHeaderWrapper",
            align: "center"
        },
        // {
        //     title: '取样部位',
        //     width: 70,
        //     dataIndex: 'smapleLocation',
        //     key: 'smapleLocation',
        //     align: "center"
        // },
        {
            title: '样品提供单位',
            dataIndex: 'sampleUnit',
            key: 'sampleUnit',
            className: "FirstLevelHeaderWrapper",
            align: "center"
        },
        // {
        //     title: '类型',
        //     width: 100,
        //     dataIndex: 'atlasType',
        //     key: 'atlasType',
        //     align: "center"
        // },
        // {
        //     title: '序列提交时间',
        //     width: 150,
        //     dataIndex: 'sequenceTime',
        //     key: 'sequenceTime',
        //     align: "center"
        // },
    ];

    const onItemClick = (record:AtlasEntity) =>{
        transaction(() => {
            imageLibraryStore.isFrontDetailOpen = true
            imageLibraryStore.frontDetailEntity = record
        })
    }

    const onSizeChange = (page:number, pageSize:number) => {
        transaction(() => {
            imageLibraryStore.frontPagination.pageNum = page;
            imageLibraryStore.frontPagination.pageSize = pageSize
            imageLibraryStore.frontCondition.pageNum = page;
            imageLibraryStore.frontCondition.pageSize = pageSize
            onQuery()
        })
    }

    const onQuery = () => {
        imageLibraryStore.getAtlasList(imageLibraryStore.frontCondition)
    }

    const onReset = () => {
        imageLibraryStore.onFrontReset()
        form.setFieldsValue(imageLibraryStore.frontCondition)
        onQuery()
    }

    const FirstLevelSearch = () => {
        return (<Form form={form} labelAlign={"right"} style={{maxWidth: "none", padding: "5px"}} wrapperCol={{span: "15"}}><Row>
            <Col span={6} offset={1}><Form.Item name={"atlasNumber"} labelCol={{span: "7"}} label={"图谱编号"}><Input
                onChange={(e) => imageLibraryStore.frontCondition.atlasNumber = e.target.value}
                value={imageLibraryStore.frontCondition.atlasNumber}/></Form.Item></Col>
            <Col span={6} offset={1}><Form.Item name={"sampleNumber"} labelCol={{span: "7"}} label={"采样编号"}><Input
                onChange={(e) => imageLibraryStore.frontCondition.sampleNumber = e.target.value}
                value={imageLibraryStore.frontCondition.sampleNumber}/></Form.Item></Col>
            <Col span={6} offset={1}><Form.Item name={"medicineName"} labelCol={{span: "7"}} label={"药材名"}><Input
                onChange={(e) => imageLibraryStore.frontCondition.medicineName = e.target.value}
                value={imageLibraryStore.frontCondition.medicineName}/></Form.Item></Col>
            <Col span={3}><Button onClick={onExpendClick}
                                  icon={imageLibraryStore.isFrontDetailOpen ? <UpOutlined/> : <DownOutlined/>}
                                  type={"link"}>{imageLibraryStore.isFrontExpend ? "折叠" : "展开"}</Button></Col>
        </Row></Form>)
    }

    const SecondLevelSearch = () => {
        return (<Form form={form} labelAlign={"right"} style={{maxWidth: "none"}} wrapperCol={{span: "15"}}><Row>
            <Col span={6} offset={1}><Form.Item name={"originalPlant"} labelCol={{span: "7"}} label={"基原植物"}><Input
                onChange={(e) => imageLibraryStore.frontCondition.originalPlant = e.target.value}
                value={imageLibraryStore.frontCondition.originalPlant}/></Form.Item></Col>
            <Col span={6} offset={1}><Form.Item name={"latinName"} labelCol={{span: "7"}} label={"拉丁名 "}><Input
                onChange={(e) => imageLibraryStore.frontCondition.latinName = e.target.value}
                value={imageLibraryStore.frontCondition.latinName}/></Form.Item></Col>
            <Col span={6} offset={1}/>
            <Col span={3}/>
        </Row></Form>)
    }

    const onChangeTab = (key: string)=> {
        setTabKey(key)
    }

    const expandedRowRender = (record:AtlasEntity)=> {
        let items: TabsProps['items'] = [];
        record.tabList.forEach((element:AtlasEntity, index)=> {
            items?.push({
                key: index+'',
                label: element.atlasType
            })
        })
        const iColumns: TableColumnsType<AtlasEntity> = [
            { title: '图谱标号', dataIndex: 'atlasNumber', key: 'atlasNumber', align: "center"},
            { title: '采样编号', dataIndex: 'sampleNumber', key: 'sampleNumber', align: "center" },
            { title: '提交时间', dataIndex: 'createtime', key: 'createtime', align: "center"},
            {title: '鉴定人', dataIndex: 'appraiser', key: 'appraiser', align: "center"},
            {title: '责任人', dataIndex: 'dutyPerson', key: 'dutyPerson', align: "center"},
            { title: '取样部位', dataIndex: 'smapleLocation', key: 'smapleLocation', align: "center" }
        ];
        return (
                <SecondLevelWrapper style={{margin: "15px 15px 15px 52px"}}>
                    <Table
                        rowKey={record.id}
                        caption={<Tabs tabBarGutter={15} tabBarStyle={{marginBottom: "10px", height: "35px"}} style={{paddingLeft: "10px"}} defaultActiveKey={tabKey} items={items} onChange={onChangeTab} />}
                        rowClassName={(type, index, intent) => {
                            return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                        }}
                        onRow={(record) => {
                            return {
                                onClick:() =>  onItemClick(record),
                            }
                        }}
                        bordered={true}
                        size={'small'}
                        columns={iColumns}
                        dataSource={record.tabList[`${Number(tabKey)}`].tabList} 
                        pagination={false} />
                </SecondLevelWrapper>
        )
    }

    return (
        <Wrapper>
            <SearchWrapper>
                <SearchTitleWrapper>
                    <div className={"searchTitle"}>查询区域</div>
                    <Space className={"searchButton"} size={"small"} align={"start"} direction={"horizontal"}>
                        <Button onClick={onQuery} icon={<SearchOutlined/>} type={"primary"}>查询</Button>
                        <Button onClick={onReset} icon={<RedoOutlined/>} ghost={true} type={"primary"}>重置</Button>
                    </Space>
                </SearchTitleWrapper>
                <Line/>
                <Collapse
                    activeKey={imageLibraryStore.isFrontExpend ? ['1'] : ["0"]}
                    defaultActiveKey={['0']} ghost>
                    <Collapse.Panel collapsible={"icon"} showArrow={false} key={1} header={<FirstLevelSearch/>}>
                        <SecondLevelSearch/>
                    </Collapse.Panel>
                </Collapse>
            </SearchWrapper>
            <ContentWrapper>
                <Table
                    style={{margin:"20px 20px 0 20px"}}
                    rowClassName={(type, index, intent) => {
                        return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                    }}
                    rowKey={record => {
                        return record.originalPlant
                    }}
                    bordered={true}
                    columns={columns}
                    expandable={{
                        columnWidth: 100,
                        expandedRowRender,
                        expandIcon: ({ expanded, onExpand, record }) =>
                            !expanded ? (<DownOutlined onClick={e => onExpand(record, e)}/>)
                                : (<UpOutlined onClick={e => onExpand(record, e)} />),
                        defaultExpandedRowKeys: ['']
                    }}
                    scroll={{x: 1000, y: 400}}
                    pagination={false}
                    dataSource={imageLibraryStore.frontDataSource}
                    size={"middle"}
                />
                <Pagination
                    total={imageLibraryStore.frontPagination.total}
                    size={"small"}
                    style={{margin:"5px 20px 20px 0", alignSelf:"end"}}
                    showQuickJumper={true}
                    showSizeChanger={true}
                    defaultPageSize={10}
                    hideOnSinglePage={true}
                    onChange={onSizeChange}
                    current={imageLibraryStore.frontPagination.pageNum}
                />
            </ContentWrapper>
            <Modal
                open={imageLibraryStore.isFrontDetailOpen}
                onCancel={onClose}
                closable={true}
                centered={true}
                destroyOnClose={true}
                footer={null}
                mask={true}
                maskClosable={true}
                width={"1200px"}>
                <AtlasDetail detail={imageLibraryStore.frontDetailEntity}/>
            </Modal>
        </Wrapper>
    );
}

export default observer(AtlasList) ;

const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #EDEFEF;
    padding: 15px 20px;
    overflow: hidden;

    .tableItemWhite {
      background: white;
    }

    .tableItemGray {
      background: #F9FAFD;
    }

    .ant-form-item {
      margin-bottom: 0px;
    }

  }
`;
const SearchWrapper = styled.div`
  & {
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
  }
`;
const SearchTitleWrapper = styled.div`
  & {
    display: flex;
    justify-content: space-between;
    margin: 15px 20px 13px 20px;

    .searchTitle {
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      line-height: 32px;
      flex: 1;
    }
  }
`;

const Line = styled.div`
  & {
    height: 0.5px;
    border: 1px solid #EAEDF7;
  }
`;
const ContentWrapper = styled.div`
  & {
    flex: 1;
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;
const SecondLevelWrapper = styled.div`
  & {
    .ant-table-wrapper .ant-table-thead >tr>th,
    .ant-table-wrapper .ant-table-thead >tr>td {
      background: #eeeeee;
      font-size: 12px;
      color: #444444;
      font-weight: 600;
      padding: 4px 4px;
    }
    .ant-table-wrapper .ant-table-container table>thead>tr:first-child >*:first-child {
      border-radius: 0px;
    }
    .ant-table-wrapper .ant-table-container table>thead>tr:first-child >*:last-child {
      border-radius: 0px;
    }
    .ant-table-wrapper table {
      border-radius: 0;
    }
  }
`;
